
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shipping-and-storage-services",
      function () {
        return require("private-next-pages/shipping-and-storage-services/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shipping-and-storage-services"])
      });
    }
  